/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
  let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  let h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  let m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return Y + M + D;
};

/**
 *
 * @returns
 * 得到12个月之前得时间
 */
const getLast12Months = () => {
  var last12Months = [];
  var today = new Date();
  var year = today.getFullYear();
  today.setMonth(today.getMonth());
  for (var i = 0; i < 12; i++) {
    last12Months[11 - i] =
      today.getFullYear() + "-" + fillZero(Number(today.getMonth()) + 1, 2); //这里+1是因为js 的月份是0-11
    if (today.getMonth == 0) {
      today.setFullYear(Number(year) - 1);
    }
    today.setMonth(Number(today.getMonth() - 1));
  }
  return last12Months;
};
//补零操作，保证月份为1位的时候补充前置0
function fillZero(num, fill) {
  var len = ("" + num).length;
  return Array(fill > len ? fill - len + 1 || 0 : 0).join(0) + num;
}
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStore = (name) => {
  if (!name) return;
  return window.localStorage.getItem(name);
};
/**
 * 删除localStorage
 */
const removeStore = (name) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
  let date = new Date();
  date.setDate(date.getDate() + day);
  document.cookie = name + "=" + value + ";expires=" + date;
}

/**
 * 获取cookie
 **/
function getCookie(name) {
  let reg = RegExp(name + "=([^;]+)");
  let arr = document.cookie.match(reg);
  if (arr) {
    return arr[1];
  } else {
    return "";
  }
}
/**
 * 删除cookie
 **/
function delCookie(name) {
  setCookie(name, null, -1);
}

/**
 * 防抖函数
 * @param method 事件触发的操作
 * @param delay 多少毫秒内连续触发事件，不会执行
 * @returns {Function}
 */
function debounce(method, delay) {
  let timer = null;
  return function () {
    let self = this,
      args = arguments;
    timer && clearTimeout(timer);
    timer = setTimeout(function () {
      method.apply(self, args);
    }, delay);
  };
}

// 下载 xml 文件
function downloadXmlFile(xmlString, fileName) {
  const blob = new Blob([xmlString], { type: "text/xml" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.style.display = "none";
  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * 导出
 **/
export {
  timestampToTime,
  getLast12Months,
  setStore,
  getStore,
  removeStore,
  setCookie,
  getCookie,
  delCookie,
  debounce,
  downloadXmlFile, // 字符串转xml 并下载
};



// WEBPACK FOOTER //
// ./src/utils/util.js